export default __webpack_public_path__ + "static/media/mute.4a7bd74c.svg";